
import React, { useState, useRef, useEffect } from "react";
import DarkLightMode from "../../components/DarkLightMode";
import LanguageSwitch from "../../components/LanguageSwitch";
import MaxMinWindow from "../../components/MaxMinWindow";
import UserAccount from "./UserAccount";
import Logo from "./Logo";
import SidebarToggle from "./SidebarToggle";
import ShareDropdown from "../doc/ShareDropdown";
import ShareIcon from "../../../src/icons-svg/share_icon(2).svg";
import config from "../../config";

const Header = ({ selectedDoc, language }) => {
  const [modalShare, setModalShare] = useState(false);
  const dropdownRef = useRef(null);

  const shareUrl = selectedDoc?.uuid
    ? `${config().HELP_URL}/displayDoc?docUuid=${selectedDoc.uuid}&language=${language}`
    : "";

  // Dış tıklama ile kapatma
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setModalShare(false);  
      }
    };

    if (modalShare) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalShare]);

  return (
    <header
      className="fixed top-0 left-0 right-0 h-14 shadow flex items-center justify-between px-4 z-50"
      style={{ backgroundColor: "#1D477F" }}
    >
      <div className="flex items-center space-x-4">
        <SidebarToggle />
        <Logo />
      </div>

      <div className="flex items-center relative">
        {/* Paylaş ikonu ve dropdown */}
        <div className="relative flex items-center space-x-4" ref={dropdownRef}>
          <button
            onClick={() => setModalShare((prev) => !prev)}
            aria-label="Paylaş"
            className="relative z-10"
          >
            <img
              src={ShareIcon}
              alt="Paylaş"
              className="w-5 h-5 object-contain cursor-pointer" style={{width:"14px", height:"14px"}}
            />
          </button> 

          <ShareDropdown
            visible={modalShare}
            onClose={() => setModalShare(false)}
            url={shareUrl}
          />
        </div>

        <DarkLightMode />
        <MaxMinWindow />
        <LanguageSwitch />
        <UserAccount />
      </div>
    </header>
  );
};

export default Header;








